export enum AllowCreateInvoiceOption {
    NotAllowed = 0,
    Allowed = 1
}
